(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("hqnuF", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $caf716bbd45313ee$export$6503ec6e8aabbaf; }, function (v) { return $caf716bbd45313ee$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $caf716bbd45313ee$export$f7ad0328861e2f03; }, function (v) { return $caf716bbd45313ee$export$f7ad0328861e2f03 = v; });
var $caf716bbd45313ee$export$6503ec6e8aabbaf;
var $caf716bbd45313ee$export$f7ad0328861e2f03;
"use strict";
var $caf716bbd45313ee$var$mapping = {};
function $caf716bbd45313ee$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$caf716bbd45313ee$var$mapping[keys[i]] = pairs[keys[i]];
}
function $caf716bbd45313ee$var$resolve(id) {
    var resolved = $caf716bbd45313ee$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$caf716bbd45313ee$export$6503ec6e8aabbaf = $caf716bbd45313ee$var$register;
$caf716bbd45313ee$export$f7ad0328861e2f03 = $caf716bbd45313ee$var$resolve;

});

var $9f10293816409634$exports = {};

(parcelRequire("hqnuF")).register(JSON.parse('{"eEdY6":"index.f6b449f5.js","f1VEZ":"worker.ba9474a5.js","192U9":"worker.cfed56d1.js","aQYxc":"worker.29a560c5.js","eNhid":"zappar-cv.315eebda.wasm","bDGgf":"face_mesh_face_model.9f3b859a.zbin","kdalY":"face_mesh_full_head_simplified_model.caf9de0a.zbin","iM80n":"face_tracking_model.624095d1.zbin","hq0mX":"macula.cb4c3f85.png","femmd":"cataracts.3e6ec60a.png","bbV0l":"bluenoise.cc4847c7.png","5Swzl":"camouflage-1.f199d488.png","kD5ss":"camouflage-2.ebc92aae.png","99VnP":"camouflage-3.2b244d66.png","f3Yyz":"camouflage-4.1f844b97.png","anoQy":"camouflage-5.142187c1.png","3aUHn":"tunnel-1.4dff8715.png","wadZo":"tunnel-2.dcfd3fec.png","9vMEj":"tunnel-3.6ef23598.png","7nwIx":"tunnel-4.dfeacddb.png","6ob2k":"tunnel-5.66cd80c6.png","3nQMt":"glaucoma-1.938075b0.png","goKD6":"glaucoma-2.50fa29f1.png","kzspj":"glaucoma-3.210b26c6.png","c706f":"glaucoma-4.56535b37.png","jMzmp":"glaucoma-5.e0cc49b7.png","8IdKL":"worker.834f3edf.js","jTa90":"worker.03c950bb.js","16oX0":"zappar-cv.1ce8bf42.wasm","fvGib":"face_mesh_face_model.9f3b859a.zbin","7epEH":"face_mesh_full_head_simplified_model.caf9de0a.zbin","3L11X":"face_tracking_model.624095d1.zbin","2ngYy":"VrControllerImage.f8d6837c.jpg","jNFIT":"HeadsetReferenceOnly.4b4164db.jpg","j8jtG":"CameraPopup.6c75acea.png","5qwlj":"VRwarningIcon.81886fcb.svg","3ZZKc":"index.b7b3e8f1.css"}'));

})();
//# sourceMappingURL=index.303ccd88.js.map
